import React, { useState } from "react";
import RequestService from "../../services/request.service";


import '../Reportes/mi_reporte.scss';

// // // import { Modal, Row, Form, Button, Col, InputGroup } from 'react-bootstrap'
import { Button, Modal, Table, Form } from 'react-bootstrap'

// // import { Formik } from 'formik';
// // import * as yup from 'yup';


import { toast } from 'react-toastify'



import Dialog from '../../services/Dialogs'
// // import { confirm } from '../../widgets/confirm'

import './mesa.scss';


import moment from 'moment'

import Pagination from "../../services/Pagination";


import labelPrivilegio from '../../widgets/roles'


// import EditarTramite from './Modales/editarTramite'
import EditarTramite from './editarTramite'


// // import { SERVER_ } from  '../../config';

import AuthService from "../../features/auth/auth.service";


import ModalDetalleCobranza from '../Tramites/ModalDetalleCobranza'
import ModalAnexoMesa from './ModalAnexoMesa'

import ModalReporte from './ModalReporte'

import ModalInformeTramite from './ModalInformeTramite'


import ModalNotasTramite from './ModalNotasTramite'


import ModalEditarInformacionSolicitante from './ModalEditarInformacionSolicitante'


import ModalEnviarTramitePago from './ModalEnviarTramitePago'

import ModalEditarFechasAseguramiento from './ModalEditarFechasAseguramiento'


import ModalLayoutSUE from './ModalLayoutSUE'

const MesaAtencion = () => {


    const dialog = new Dialog();


  const [allSessionsCount,setCounter] = useState(0);
  const sessionsPerPage = 50
  // const [sessionsPerPage, setSessionsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);

  const [ pagina, setPagina ] = useState(0)
  const [ text_busqueda, setTextoBusqueda ] = useState('')


  const [ cargando_, setCargando ] = useState( true )

  const skull = {
    years: [],
    meses: [],
    results: [{
      asistente : { rol : '' }
    }]
  }

  const [ reporte, setReporte ] = useState<any>({...skull})

  const currentUser  = AuthService.getCurrentUser();

  const cargarMiReporte = async(page:number)=>{
    try{
      setCargando(true)
      let skip = 0
      if(page===0) skip = 0; else skip = (page*sessionsPerPage);
      let response : any = await RequestService.getEndPoint('mesa_tencion/lista_de_atencion/'+arreglo_estatus+'/'+currentUser.idsucursal.uuid+'?where='+text_busqueda+'&skip='+skip)
      // console.log(response.data)
      setPagina(page)
      // setTotalResulados(response.data.totalCount)
      setCounter(response.data.totalCount)
      // setPaginas(response.data.numberPages)

      setReporte(response.data)
      setCargando(false)
      // toast.success('La lista de Tramites del día '+fecha+' fue cargada')
    }
    catch(e){
      setCargando(false)
      toast.error('Problemas al intentar generar tu reporte. Contacta con los administradores del sistema')
    }
  }


  const busquedaEtiquetas = async () =>{
    setPagina(0)
    cargarMiReporte(0)
    setCurrentPage(1)
  }



  const enviarAEspera = async (e:any,uuid_tramite:string) => {

    try{

        await dialog.open({
          accept: 'Si',
          dialogClass: '',
          message: 'Enviar para Aseguramiento',
          // soundAccept: 'https://assets.stoumann.dk/audio/accept.mp3',
          // soundOpen: 'https://assets.stoumann.dk/audio/open.mp3',
          target: e.target,
          template: `<p><small>Deberá esperar que la aseguradora cambie el estatus de este Trámite</small></p>
                <div class="mb-3">
                  <label for="exampleInputEmail1" class="form-label">Monto del Salario</label>
                  <input type="text" name="sueldo_trabajador" class="form-control" id="exampleInputEmail1" >
                </div>

          `
        })
        let dialogo : any = await dialog.waitForUser()
        // console.log(dialogo)
        if(dialogo){
            RequestService.update('enviar_espera/'+uuid_tramite, dialogo)
            await cargarMiReporte(pagina)
            toast.success('Este tramite fue enviado a ESPERA')
        }

    }
    catch(e){
      toast.error('Problemas.')
    }

  }


  const enviarVerificacionTelefonica = async (e:any,uuid_tramite:string) => {

    try{

        await dialog.open({
          accept: 'Si',
          dialogClass: '',
          message: '¿Enviar a Verificación Telefónica?',
          // soundAccept: 'https://assets.stoumann.dk/audio/accept.mp3',
          // soundOpen: 'https://assets.stoumann.dk/audio/open.mp3',
          target: e.target,
          template: `<p>Al terminar la verificación telefónica el trámite pasará a proceso de Aseguramiento</p>`
        })
        let dialogo : any = await dialog.waitForUser()
        // console.log(dialogo)
        if(dialogo){
            let respuesta = await RequestService.update('tramite/enviar_verificacion_telefonica/'+uuid_tramite, dialogo)
            await cargarMiReporte(pagina)
            toast.success('Este tramite fue enviado a ESPERA')
        }

    }
    catch(e){
      toast.error('Problemas.')
    }

  }


  React.useEffect(() => {
    cargarMiReporte(0)
  }, []);


  const [ comments, setComments ] = useState({
    resuelto_todo : false,
    comments : []
  })

  const cargarComentarios = async (uuid_tramite:string) =>{
      try{
        let response = await RequestService.getEndPoint('tramite/comentarios_atencion/'+uuid_tramite)
        setComments(response.data)
      }
      catch(e){
        toast.error('Error al cargar los comentarios')
      }
  }


  const [ uuid_tramite_modal, setUUIDTramiteSeleccionado ] = useState<any>('')


  const [showModalRectifica, setShowModalRectifica] = useState(false);

  const handleClose = () =>{
    setShowModalRectifica(false)
  }
  const handleShowEnviarRectificacion = async (uuid_tramite:string) =>{ 
    setUUIDTramiteSeleccionado(uuid_tramite)
    setShowModalRectifica(true)
    await cargarComentarios(uuid_tramite)
  }


  const [ tipoA, setTipoA ] = useState(false)
  const [ tipoB, setTipoB ] = useState(false)
  const [ tipoC, setTipoC ] = useState(false)
  const [ tipoD, setTipoD ] = useState(false)


  const [ descripcionA, setDescripcionA ] = useState("")
  const [ descripcionB, setDescripcionB ] = useState("")
  const [ descripcionC, setDescripcionC ] = useState("")
  const [ descripcionD, setDescripcionD ] = useState("")


  const enviarRectificacion = async () => {
    try{
      if(await dialog.confirm('¿Estás seguro?',{})){
        var COMMENTS : any = []
          if(tipoA) COMMENTS.push({ descripcion : descripcionA, tipo_comentario : 1 })
          if(tipoB) COMMENTS.push({ descripcion : descripcionB, tipo_comentario : 2 })
          if(tipoC) COMMENTS.push({ descripcion : descripcionC, tipo_comentario : 3 })
          if(tipoD) COMMENTS.push({ descripcion : descripcionD, tipo_comentario : 4 })
          // console.log(COMMENTS)
        await RequestService.update('enviar_rectificacion/'+uuid_tramite_modal,{ comments : COMMENTS })
        toast.warning('El Tramite fue enviado al asesor para su rectificación de información')
        cargarMiReporte(0)
        setShowModalRectifica(false)

        setTipoA(false)
        setTipoB(false)
        setTipoC(false)
        setTipoD(false)
        setDescripcionA('')
        setDescripcionB('')
        setDescripcionC('')
        setDescripcionD('')

      }
    }
    catch(e){
      toast.error("Error al enviar a rectificación")
    }

  }





  const finalizarTramite = async (event:any,uuid_tramite:string) => {
    try{
  dialog.open({
    accept: 'Finalizar',
    cancel: 'No',
    dialogClass: 'customm',
    message: 'PENALIZACIÓN',
    // soundAccept: 'https://assets.stoumann.dk/audio/accept.mp3',
    // soundOpen: 'https://assets.stoumann.dk/audio/open.mp3',
    target: event.target,
    template: `<div class="mb-3">
                  <div className="form-check">
                    <label className="form-check-label" style="font-family:Krub">
                      <input type="radio" className="form-check-input" name="optionsRadios" value="option3" />
                      Trámite en Penalización
                    </label>
                  </div>
      </div>
      `
  })
  var respuesta : any = await dialog.waitForUser()
  // console.log(respuesta)


      if(respuesta){
        // console.log(respuesta)
        await RequestService.update('tramite/finalizar/'+uuid_tramite+'/'+respuesta.optionsRadios,{})
        cargarMiReporte(pagina)
      }
      else toast.error('Debes seleccionar una opción para poder finalizar este trámite ')
    }
    catch(e){
      toast.error('Error al intentar finalizar el trámite')
    }
  }





  const [ showEditarTramite , setShowEditarTramite ] = useState(false)
  const [ uuid_tramite , setEdit_uuid_tramite ] = useState("")
  const [ data_tramite, setDataTramiteEdit ] = useState<any>({nombres:"",paterno:"",materno:"",folio:"",curp:"",monto:0,rol:''})
  const [ departamento_edicion, setDepartamentoEdicion ] = useState<any>({})

  const editarTramite = async (event, uuid:string) => {
    try{
      setEdit_uuid_tramite(uuid)
      setShowEditarTramite(true)
      let response = await RequestService.getEndPoint('data-tramimte/'+uuid)
      // console.log(response.data)
      var formTramite : any = {
        nombres : response.data.idciudadano.nombres,
        paterno : response.data.idciudadano.paterno,
        materno : response.data.idciudadano.materno,

        folio : response.data.folio,
        curp : response.data.idciudadano.curp,
        monto : response.data.monto,


        // nombres : response.data.idciudadano.nombres,
        // paterno : response.data.idciudadano.paterno,
        // materno : response.data.idciudadano.materno,
        sexo : response.data.idciudadano.sexo,

        // folio : response.data.folio,
        // curp : response.data.idciudadano.curp,
        seguro_social : response.data.idciudadano.seguro_social,

        direccion : response.data.idciudadano.direccion,
        colonia : response.data.idciudadano.colonia,
        cp : response.data.idciudadano.cp,

        celular : response.data.idciudadano.celular,
        telefono : response.data.idciudadano.telefono,
        email : response.data.idciudadano.email,

        idafore : response.data.depto_estrategias.idafore,
        idafore_anterior : response.data.depto_estrategias.idafore_anterior,
        semanas_cotizadas : response.data.depto_estrategias.semanas_cotizadas,
        sueldo_trabajador : response.data.depto_estrategias.sueldo_trabajador,
        monto_aseguramiento : response.data.depto_estrategias.monto_aseguramiento,
        anticipo : response.data.depto_estrategias.anticipo,

        monto_rcv : response.data.depto_estrategias.monto_rcv,


        anexos_digitales : response.data.anexos_digitales


      }
      if(response.data.depto_estrategias.fecha_baja_anterior) formTramite.fecha_baja_anterior = moment(response.data.depto_estrategias.fecha_baja_anterior, 'YYYY-MM-DD').toDate()
        else formTramite.fecha_baja_anterior = moment().toDate()
          
      if(response.data.depto_estrategias.fecha_alta_anterior) formTramite.fecha_alta_anterior = moment(response.data.depto_estrategias.fecha_alta_anterior, 'YYYY-MM-DD').toDate()
        else formTramite.fecha_alta_anterior = moment().toDate()
          
      if(response.data.depto_estrategias.sindo) formTramite.sindo = moment(response.data.depto_estrategias.sindo, 'YYYY-MM-DD').toDate()
        else formTramite.sindo = null

      if(response.data.depto_estrategias.traspaso_afore) formTramite.traspaso_afore = true

      if(!response.data.idciudadano.direccion) formTramite.direccion = ""
      if(!response.data.idciudadano.colonia) formTramite.colonia = ""
      if(!response.data.idciudadano.cp) formTramite.cp = ""
      if(!response.data.idciudadano.telefono) formTramite.telefono = ""


      // console.log("formTramite")
      // console.log(formTramite)
      setDepartamentoEdicion(response.data.iddepartamento)
      setDataTramiteEdit(formTramite)
    }
    catch(e){
      toast.error('Tuvimos un error')
    }

  }

  const handleCloseEditarTramite = ()=>{
      setShowEditarTramite(false)
      cargarMiReporte(pagina)
  }






  const [ show_ModalEditarFechasAseguramiento, setModalEditarFechasAseguramiento ] = useState<boolean>(false)
  const handleShow_ModalEditarFechasAseguramiento = (tramite:any) => {
    setDataTramiteEdit(tramite)
    setModalEditarFechasAseguramiento(true)
  }
  const handleClose_ModalEditarFechasAseguramiento = () => {
      cargarMiReporte(pagina)
    setModalEditarFechasAseguramiento(false)
  }







  // const [ uuid_tramite_detalle_cobranza, setUUIDTramiteSeleccionado ] = useState<any>(false)
  const [ showModalDetalleCobranza, setShowModalDetalleCobranza ] = useState<any>(false)

  const onHideModalDetalleCobranza = () => {
    setShowModalDetalleCobranza(false)
    // setUUIDTramiteSeleccionado(uuid_tramite)
  }

            
  const detalleCobranza = (uuid_tramite:string)=>{
    setShowModalDetalleCobranza(true)
      setUUIDTramiteSeleccionado(uuid_tramite)
  }





  // const [ uuid_tramite_detalle_cobranza, setUUIDTramiteSeleccionado ] = useState<any>(false)
  const [ showModalAnexos, setShowModalAnexos ] = useState<any>(false)

  const onHideModalAnexos = () => {
    setShowModalAnexos(false)
    // setUUIDTramiteSeleccionado(uuid_tramite)
  }

            
  const detalleAnexos = (uuid_tramite:string)=>{
      setShowModalAnexos(true)
      setUUIDTramiteSeleccionado(uuid_tramite)
  }


  const [ arreglo_estatus, setEstatus ] = useState<any>([true,true,true,true,true,true,true,true,true,true,false,false,false,false,false,false,false ])
  // const [ arreglo_estatus, setEstatus ] = useState<any>([true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true])


  const todos = () =>{
    setEstatus([true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true])
  }
  const ninguno = () =>{
    setEstatus([false,false,false,false,false,false,false,false,false,false,false,false,false,false,false,false,false])
  }


  const [ showModalReportes, setShowModalReporte ] = useState<boolean>(false)

  const onHideModalReportes = () =>{
    setShowModalReporte(false)
  }



  const [ showModalInforme, setShowModalInforme ] = useState<boolean>(false)

  const onHideModalInforme = async () =>{
    await cargarMiReporte(pagina)
    setShowModalInforme(false)
  }

  const fichaTramite = (uuid_tramite:string) => {
    setUUIDTramiteSeleccionado(uuid_tramite)
    setShowModalInforme(true)
  }




  // const verificacionFinal = (tramite:any) => {
  //   console.log(tramite)
  // }



  const verificacionFinal = async(e:any, tramite:any) => {

    try{

        await dialog.open({
          accept: 'SI',
          cancel: 'NO',
          dialogClass: '',
          message: 'Que Estatus debe tener este Trámite',
          target: e.target,
          template: `
              <div class="mt-4">
              <label class="form-label">¿Se contacto con la persona?</label>
                <div class="form-check">
                  <input class="form-check-input" type="radio" name="idestatus" value="5" id="flexRadioDefault1">
                  <label class="form-check-label" for="flexRadioDefault1">
                    Pasar Cobro
                  </label>
                </div>
                <div class="form-check">
                  <input class="form-check-input" type="radio" name="idestatus" value="7" id="flexRadioDefault2" >
                  <label class="form-check-label" for="flexRadioDefault2">
                    Penalizar
                  </label>
                </div>
                <div class="form-check">
                  <input class="form-check-input" type="radio" name="idestatus" value="999" id="flexRadioDefault3" >
                  <label class="form-check-label" for="flexRadioDefault3">
                    Cancelar Trámite
                  </label>
                </div>
              </div>

          `
        })
        let dialogo : any = await dialog.waitForUser()
        // console.log(dialogo)
        if(dialogo && dialogo.idestatus){
          let res = await RequestService.update('tramite/verificacion_final/'+tramite.uuid_tramite, dialogo )
          if(res.data){
            toast.success('Se actualizo el estatus del Trámite')
            await cargarMiReporte(pagina)
          }
          
        }

    }
    catch(e){
      toast.error('Tuvimos problemas al intentar finalizar la verificación del trámite')
    }

  }





  const marcarPagoAnticipado = async ( uuid_tramite:string, index:number, pagado:boolean, e:any) =>{

    let REPORTE_ORIGINAL : any = { ...reporte }

        await dialog.open({
          accept: 'Si',
          dialogClass: '',
          message: 'Marcar de Pago anticipado',
          // soundAccept: 'https://assets.stoumann.dk/audio/accept.mp3',
          // soundOpen: 'https://assets.stoumann.dk/audio/open.mp3',
          target: e.target,
          template: `<p><small>Este proceso no podrá deshacerse</small></p>
          `
        })
        let dialogo : any = await dialog.waitForUser()
        
        if(dialogo){


            try{

              let res = await RequestService.update('tramite/pago_anticipado/'+uuid_tramite, { pagado : !pagado })
              if(res.data){
                REPORTE_ORIGINAL.results[index].pago_anticipado = !pagado  
                setReporte(REPORTE_ORIGINAL)    
                toast.warning('Se marco como pago anticipado')
              }
              else{
                REPORTE_ORIGINAL.results[index].pago_anticipado = pagado  
                setReporte(REPORTE_ORIGINAL)    
              }

            }
            catch(e){
              REPORTE_ORIGINAL[index].pago_anticipado = pagado  
              setReporte(REPORTE_ORIGINAL)
              toast.error('Tuvimos problemas al actualizar')
            }


        }


  }



  const [ show_ModalNotasTramite, setModalNotasTramite ] = useState<boolean>(false)
  const mensajesTramite = (tramite:any) => {
    setDataTramiteEdit(tramite)
    setModalNotasTramite(true)
  }
  const handleClose_ModalNotasTramite = () => {
    setModalNotasTramite(false)
  }







  const [ show_ModalEditarInformacionSolicitante, setModalEditarInformacionSolicitante ] = useState<boolean>(false)
  const [ solicitante, setSolicitante ] = useState<any>({})
  const handleShow_ModalEditarInformacionSolicitante = async(uuid_ciudadano:string) => {
    try{
      let req = await RequestService.getEndPoint(`solicitante/informacion_personal/${uuid_ciudadano}`)
      if(req.data){
        setSolicitante(req.data)
        setModalEditarInformacionSolicitante(true) 
      }
      
    }
    catch{
      toast.error('Error al intentar cargar la información del ciudadano')
    }
    
  }
  const handleClose_ModalEditarInformacionSolicitante = () => {
    setModalEditarInformacionSolicitante(false)
  }





  const [ show_ModalEnviarTramitePago, setModalEnviarTramitePago ] = useState<boolean>(false)
  const handleShow_ModalEnviarTramitePago = (tramite:any) => {
    setDataTramiteEdit(tramite)
    setModalEnviarTramitePago(true)
  }
  const handleClose_ModalEnviarTramitePago = () => {
      cargarMiReporte(pagina)
    setModalEnviarTramitePago(false)
  }




  const [ show_ModalLayoutSUE, setModalLayoutSUE ] = useState<boolean>(false)
  const handleShow_ModalLayoutSUE = () => {
    setModalLayoutSUE(true)
  }
  const handleClose_ModalLayoutSUE = () => {
    setModalLayoutSUE(false)
  }




      return (
             
          <>
              <div className="container-fluid">
                  
                  <h2>Mesa de Control de Trámites</h2>
                  <hr />

                 {
                   // JSON.stringify(reporte)
                 } 

                              <div className="">
                                <label className="form-label">Búsqueda</label>
                                <div className="input-group mb-3">
                                  <input type="text" className="form-control" onKeyDown={(e)=>{if(e.keyCode === 13){ busquedaEtiquetas() }}} placeholder="" value={text_busqueda} onChange={event => setTextoBusqueda(event.target.value)} />
                                  <button onClick={busquedaEtiquetas} className="btn btn-default" type="button" id="button-addon2"><i className="fa fa-search" /></button>
                                </div>
                              </div>




                              <div className="row">
                                  
                                  <div className="col">
                                    
                                      <div key={`inline-checkbox`} className="">

                                      {
                                        // JSON.stringify(arreglo_estatus)
                                      }

                                        <Form.Check inline name="group1" type="checkbox" label="CAPTURA" checked={arreglo_estatus[0]} onChange={(e)=>{ var ne = [...arreglo_estatus]; ne[0] = e.target.checked;  setEstatus(ne);}} id={`opciones_1`} />
                                        <Form.Check inline name="group2" type="checkbox" label="MESA DE ATENCIÓN" checked={arreglo_estatus[1]} onChange={(e)=>{ var ne = [...arreglo_estatus]; ne[1] = e.target.checked;  setEstatus(ne);}} id={`opciones_2`} />
                                        <Form.Check inline name="group3" type="checkbox" label="RECTIFICACIÓN" checked={arreglo_estatus[2]} onChange={(e)=>{ var ne = [...arreglo_estatus]; ne[2] = e.target.checked;  setEstatus(ne);}} id={`opciones_3`} />
                                        <Form.Check inline name="group4" type="checkbox" label="VERIFICACIÓN TELEFÓNICA" checked={arreglo_estatus[3]} onChange={(e)=>{ var ne = [...arreglo_estatus]; ne[3] = e.target.checked;  setEstatus(ne);}} id={`opciones_4`} />
                                        <Form.Check inline name="group5" type="checkbox" label="ASEGURAMIENTO" checked={arreglo_estatus[4]} onChange={(e)=>{ var ne = [...arreglo_estatus]; ne[4] = e.target.checked;  setEstatus(ne);}} id={`opciones_5`} />
                                        <Form.Check inline name="group6" type="checkbox" label="PRODUCCIÓN ACEPTADA" checked={arreglo_estatus[5]} onChange={(e)=>{ var ne = [...arreglo_estatus]; ne[5] = e.target.checked;  setEstatus(ne);}} id={`opciones_6`} />
                                        <Form.Check inline name="group7" type="checkbox" label="SIN PAGAR" checked={arreglo_estatus[6]} onChange={(e)=>{ var ne = [...arreglo_estatus]; ne[6] = e.target.checked;  setEstatus(ne);}} id={`opciones_7`} />
                                        <Form.Check inline name="group8" type="checkbox" label="LIQUIDADO" checked={arreglo_estatus[7]} onChange={(e)=>{ var ne = [...arreglo_estatus]; ne[7] = e.target.checked;  setEstatus(ne);}} id={`opciones_8`} />
                                        <Form.Check inline name="group9" type="checkbox" label="PENALIZADO" checked={arreglo_estatus[8]} onChange={(e)=>{ var ne = [...arreglo_estatus]; ne[8] = e.target.checked;  setEstatus(ne);}} id={`opciones_9`} />
                                        <Form.Check inline name="group10" type="checkbox" label="CANCELADO" checked={arreglo_estatus[9]} onChange={(e)=>{ var ne = [...arreglo_estatus]; ne[9] = e.target.checked;  setEstatus(ne);}} id={`opciones_10`} />
                                        
                                      </div>



{/*
                                      <div key={`inline-checkbox3`} className="">

                                        <Form.Check inline name="group11" type="checkbox" label="PAGO ANTICIPADO" checked={arreglo_estatus[10]} onChange={(e)=>{ var ne = [...arreglo_estatus]; ne[10] = e.target.checked;  setEstatus(ne);}} id={`opciones_11`} />
                                        <Form.Check inline name="group12" type="checkbox" label="ADELANTO ABONADO" checked={arreglo_estatus[11]} onChange={(e)=>{ var ne = [...arreglo_estatus]; ne[11] = e.target.checked;  setEstatus(ne);}} id={`opciones_12`} />
                                        <Form.Check inline name="group13" type="checkbox" label="DEBE LIQUIDAR" checked={arreglo_estatus[12]} onChange={(e)=>{ var ne = [...arreglo_estatus]; ne[12] = e.target.checked;  setEstatus(ne);}} id={`opciones_13`} />
                                        <Form.Check inline name="group14" type="checkbox" label="LIQUIDADO" checked={arreglo_estatus[13]} onChange={(e)=>{ var ne = [...arreglo_estatus]; ne[13] = e.target.checked;  setEstatus(ne);}} id={`opciones_14`} />
                                        <Form.Check inline name="group15" type="checkbox" label="RETENER EL PAGO" checked={arreglo_estatus[14]} onChange={(e)=>{ var ne = [...arreglo_estatus]; ne[14] = e.target.checked;  setEstatus(ne);}} id={`opciones_15`} />
                                        <Form.Check inline name="group16" type="checkbox" label="COBRAR PENALIZACIÓN" checked={arreglo_estatus[15]} onChange={(e)=>{ var ne = [...arreglo_estatus]; ne[15] = e.target.checked;  setEstatus(ne);}} id={`opciones_16`} />
                                        <Form.Check inline name="group17" type="checkbox" label="ENVIAR A PAGO" checked={arreglo_estatus[16]} onChange={(e)=>{ var ne = [...arreglo_estatus]; ne[16] = e.target.checked;  setEstatus(ne);}} id={`opciones_17`} />
                                        
                                      </div>


*/}



                                      <ul className="list-inline">
                                        <li className="list-inline-item"><small className="cursor" onClick={()=>{todos()}}>Todos</small> / <small className="cursor" onClick={()=>{ninguno()}}>Ninguno</small></li>
                                        <li className="list-inline-item"><button type="button" onClick={()=>{setShowModalReporte(true)}} className="btn btn-sm btn-link">Reporte</button></li>
                                        <li className="list-inline-item"><button type="button" onClick={()=>{handleShow_ModalLayoutSUE()}} className="btn btn-sm btn-link">Layout SUE</button></li>
                                      </ul>

                                      <p className="mb-3">
                                        
                                      </p>

                                  </div>

                              </div>



{
//   <ul className="list-inline">
//   <li className="list-inline-item">
//       <button type="button" className="btn btn-link">En Prc</button>
//   </li>
// </ul>
}
                 

                          {  (!cargando_) && (

                              <>



                                      



                                     {
                                       reporte.results.length > 0 && (

                                         <>


                                         <h5>Tramites</h5>


                                          <Table responsive="lg">
                                            <thead>
                                              <tr>
                                                <th className="v" scope="col">Estatus</th>
                                                <th className="v" scope="col"></th>
                                                <th className="v" scope="col">Solicitante</th>
                                                <th className="v" scope="col">Asesor</th>
                                                <th className="v" scope="col">Rol</th>
                                                <th className="v" scope="col">Gerente</th>
                                                <th className="v" scope="col">Asistente</th>
                                                <th className="v" scope="col" style={{fontSize:10}}>Folio / Monto</th>
                                                <th className="v" scope="col"></th>
                                                <th className="v" scope="col"></th>
                                                <th className="v" scope="col"></th>
                                                <th className="v" scope="col"></th>
                                                <th className="v" scope="col"></th>
                                                <th className="v" scope="col">Creación</th>
                                                <th className="v" scope="col">Estatus Pago</th>
                                                <th className="v" scope="col"></th> 
                                              </tr>
                                            </thead>
                                            <tbody>
                                              {


                                                reporte.results.map( (cual:any,indice:number) =>
                                                    <tr key={ Math.random().toString(36).substr(2, 9) } style={{fontSize:12}}>
                                                      <td className="v text-left" style={{"width":"160px"}}>
                                                              


                                                        {
                                                          cual.idestatus === 1 && (
                                                              <span className={'badge cursor estatus_'+cual.idestatus }> {cual.estatus}</span>
                                                          )
                                                        }
                                                        {
                                                          cual.idestatus === 2 && (
                                                              <span  className={'badge estatus_'+cual.idestatus }> {cual.estatus}</span>
                                                          )
                                                        }

                                                        {
                                                          cual.idestatus === 3 && (
                                                              <span  className={'badge estatus_'+cual.idestatus }> {cual.estatus}</span>
                                                          )
                                                        }

                                                        {
                                                          cual.idestatus === 4 && (
                                                              <span  className={'badge estatus_'+cual.idestatus }> {cual.estatus} { cual.asegurado === 1 && ( <i className="fa fa-check-circle" /> ) }</span>
                                                          )
                                                        }

                                                        {
                                                          cual.idestatus === 5 && (
                                                              <span onClick={()=>{detalleCobranza(cual.uuid_tramite)}} className={'badge cursor estatus_'+cual.idestatus }> {cual.estatus}</span>
                                                          )
                                                        }

                                                        {
                                                          cual.idestatus === 6 && (
                                                              <span  className={'badge estatus_'+cual.idestatus }> {cual.estatus}</span>
                                                          )
                                                        }
                                                        {
                                                          cual.idestatus === 7 && (
                                                              <span  className={'badge estatus_'+cual.idestatus }> {cual.estatus}</span>
                                                          )
                                                        }
                                                        {
                                                          cual.idestatus === 8 && (
                                                              <span  className={'badge estatus_'+cual.idestatus }> {cual.estatus}</span>
                                                          )
                                                        }
                                                        {
                                                          cual.idestatus === 9 && (
                                                              <span onClick={(e)=>{verificacionFinal(e,cual)}} className={'badge cursor estatus_'+cual.idestatus }> {cual.estatus}+</span>
                                                          )
                                                        }

                                                        {
                                                          cual.idestatus === 999 && (
                                                              <span style={{color:'red'}} className={'badge estatus_'+cual.idestatus }> Cancelada <i className="fa fa-warning" style={{color:'red'}} /></span>
                                                          )
                                                        }



                                                      </td>

                                                      <td className="v no_onmobile text-left" style={{width:"30px"}}>
                                                          <i onClick={()=>(handleShow_ModalEditarInformacionSolicitante(cual.uuid_ciudadano))} className="fa fa-edit cursor"/>
                                                      </td>


                                                      <td className="v text-left"  >
                                                          <p className="nm"><small><b>{cual.nombres}</b></small></p>
                                                          <small>{cual.paterno} {cual.materno}</small>
                                                      </td>

                                                      <td className="v no_onmobile text-left table-primary" style={{"width":"150px"}}>
                                                        {
                                                          cual.uuid_asesor && (
                                                              <>

                                                                 <p className="nm"><b>{ cual.nombres_asesor } </b></p>

                                                                    {
                                                                      cual.captura_asistente && (<i className="fa fa-hand-peace-o" /> )
                                                                    }
                                                                 <small> { cual.paterno_asesor } { cual.materno_asesor }</small>

                                                              </>

                                                          )
                                                        }

                                                        {' '}

                                                            {
                                                              cual.idsupervisor && (<i title={`${cual.idsupervisor.nombres} ${cual.idsupervisor.paterno} ${cual.idsupervisor.materno}`} className="fa fa-user-secret" />)
                                                            }

                                                      </td>

                                                      <td className="v no_onmobile text-left table-primary" style={{"width":"150px"}}>

                                                            {
                                                              labelPrivilegio(cual.rol)
                                                            }

                                                      </td>







                                                      <td className="v no_onmobile text-left" style={{"width":"150px"}}>
                                                        {
                                                          cual.uuid_gerente && (
                                                              <>

                                                                 <p className="nm"><b>{ cual.nombres_gerente } </b></p>
                                                                 <small>{ cual.paterno_gerente } { cual.materno_gerente }</small>
                                                              </>

                                                          )
                                                        }
                                                      </td>
                                                      <td className="v no_onmobile text-left" style={{"width":"150px"}}>
                                                        {
                                                          cual.captura_asistente && (
                                                              <>

                                                                 <p className="nm"><b>{ cual.asistente.nombres } </b></p>
                                                                 <small>{ cual.asistente.paterno } { cual.asistente.materno }</small>
                                                              </>

                                                          )
                                                        }
                                                      </td>

                                                      {
                                                        // <td className="v no_onmobile text-left" style={{"width":"160px"}}>
                                                        //   <b>{cual.departamento}</b>
                                                        // </td>
                                                      }


                                                      {
                                                        // <td className="v no_onmobile text-left" style={{"width":"200px"}}><small>{cual.paterno}</small></td>
                                                        // <td className="v no_onmobile text-left" style={{"width":"200px"}}><small>{cual.materno}</small></td>
                                                      }
                                                      <td className="v no_onmobile text-left" style={{width : 100}}>
                                                        <small className="cursor" onClick={(e)=>{fichaTramite(cual.uuid_tramite)}}>{cual.folio}</small>
                                                         <p className="nm">
                                                          $ {(cual.monto_aseguramiento||0).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}
                                                        </p>
                                                      </td>
                                                      <td className="v no_onmobile text-center" style={{"width":"40px"}}>

                                                      {
                                                        // JSON.stringify(cual.numero_mensajes)
                                                      }

                                                            <button type="button" onClick={()=>{mensajesTramite(cual)}} className="btn btn-primary btn-link btn-xs position-relative">
                                                              <i className={'fa '+( cual.numero_mensajes > 0 ? 'fa-sticky-note' : 'fa-sticky-note-o') } />

                                                                {
                                                                  cual.numero_mensajes > 0 && (
                                                                      <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
                                                                        {cual.numero_mensajes}
                                                                        <span className="visually-hidden">Mensajes</span>
                                                                      </span>
                                                                  )
                                                                }

                                                            </button>


                                                         {
                                                          // <Button onClick={()=>{mensajesTramite(cual)}} className="nm" size="sm" variant="link"><i className={'fa '+( cual.numero_mensajes > 0 ? 'fa-sticky-note' : 'fa-sticky-note-o') } /></Button>
                                                        }
                                                      </td>
                                                      <td className="v no_onmobile text-center" style={{"width":"40px"}}>
                                                        {
                                                          (cual.idestatus !== 1) && (
                                                              <Button onClick={()=>{detalleAnexos(cual.uuid_tramite)}} className="nm" size="sm" variant="link"><i className="fa fa-folder" /></Button>
                                                          )
                                                        }
                                                      </td>
                                                      <td className="v text-right" style={{"width":"40px"}}>
                                                        {
                                                          cual.idestatus === 2 && (
                                                              <Button onClick={()=>{handleShowEnviarRectificacion(cual.uuid_tramite)}} className="nm" size="sm" variant="outline-warning"><i className="fa fa-list" /></Button>
                                                          )
                                                        }

                                                        {
                                                          (cual.idestatus === 4 || cual.idestatus === 5 || cual.idestatus === 8) && (
                                                              <Button className="nm" onClick={(e)=>{finalizarTramite(e,cual.uuid_tramite)}} size="sm" variant="outline-primary"><i className="fa fa-warning" /></Button>
                                                          )
                                                        }

                                                      </td>
                                                      <td className="v text-right" style={{"width":"40px"}}>
                                                        {
                                                          // cual.idestatus === 2 && (
                                                          //     <Button onClick={(e)=>{enviarAEspera(e,cual.uuid_tramite)}} className="nm" size="sm" variant="outline-primary"><i className="fa fa-fast-forward" /></Button>
                                                          // )
                                                        }

                                                        {
                                                          cual.idestatus === 2 && (
                                                              <Button onClick={(e)=>{enviarVerificacionTelefonica(e,cual.uuid_tramite)}} className="nm" size="sm" variant="outline-primary"><i className="fa fa-phone" /></Button>
                                                          )
                                                        }

                                                      </td>
                                                      <td className="v" style={{"width":"40px"}}>

                                                        {
                                                          (cual.idestatus === 2) && (
                                                              <Button onClick={(event)=>{editarTramite(event,cual.uuid_tramite)}} className="nm" size="sm" variant="outline-warning"><i className="fa fa-edit" /></Button>
                                                          )
                                                        }


                                                        {
                                                          ([6,9].indexOf(cual.idestatus) > -1 && ["35b8ad2b-5b6e-4203-88bd-1dc138b9b388","082f0006-5d73-45e0-a28b-9441178e141d"].indexOf(currentUser.uuid) > -1 )&& (
                                                              <Button onClick={(event)=>{handleShow_ModalEditarFechasAseguramiento(cual)}} className="nm" size="sm" variant="outline-danger"><i className="fa fa-edit" /></Button>
                                                          )
                                                        }


                                                        
                                                      </td>
                                                      <td className="v text-right" style={{"width":"140px"}}>
                                                      <p className="nm">{moment(cual.fecha_tramite).format('DD/MMMM/YYYY').toUpperCase()}</p>
                                                          <small>{moment(cual.fecha_tramite).from(moment())}</small>
                                                      </td>

                                                    <td className="v text-center" style={{"width":"150px"}}>
                                                        <p className="nm">{ cual.estatus_pago }</p>
                                                        {
                                                          // JSON.stringify(cual)
                                                        }
                                                    </td>
                                                    <td className="v text-center" style={{"width":"40px"}}>
                                                      {
                                                        // <input type="checkbox" checked={cual.pago_anticipado} disabled={cual.pago_anticipado} onChange={(event:any)=>{marcarPagoAnticipado(cual.uuid_tramite,indice,cual.pago_anticipado,event)}} />
                                                      }

                                                      {
                                                        // JSON.stringify(cual.idestatus_pago)
                                                      }


                                                                {
                                                                  // (cual.idestatus_pago === null && cual.idestatus !== 1) && (
                                                                  //     <>
                                                                  //       <Button onClick={()=>{handleShow_ModalEnviarTramitePago(cual)}} variant="link" size="sm"><i className="fa fa-money" /></Button>
                                                                  //     </>
                                                                  // )
                                                                }

                                                                {
                                                                  // [1 ].indexOf(cual.idestatus_pago) > -1 && (
                                                                  //     <>
                                                                  //       🪙
                                                                  //     </>
                                                                  // )
                                                                }

                                                                {
                                                                  // [ 3].indexOf(cual.idestatus_pago) > -1 && (
                                                                  //     <>
                                                                  //       💰
                                                                  //     </>
                                                                  // )
                                                                }

                                                        <Button onClick={()=>{handleShow_ModalEnviarTramitePago(cual)}} variant="link" size="sm"><i className="fa fa-money" /></Button>


                                                    </td>


                                                    </tr>
                                                 )
                                              }

                                            </tbody>
                                          </Table>


                                          <Pagination
                                            itemsCount={allSessionsCount}
                                            itemsPerPage={sessionsPerPage}
                                            currentPage={currentPage}
                                            setCurrentPage={setCurrentPage}
                                            cambiarPaginaEvento={cargarMiReporte}
                                            alwaysShown={false}
                                          />




                                          </>



                                         )
                                     }






                              </>

                           )}

                          {  cargando_ && (

                              <>
                                <div className="loader">
                                  <div className="loaderBar"></div>
                                </div>
                              </>


                           )}




              </div>






      <Modal
        show={showModalRectifica}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <h5 className="nm">ENVIAR TRÁMITE A RECTIFICACIÓN</h5>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>

        <p>Para ayudar al asesor a rectificar la información del trámite indica que tipo de corrección debe de hacer:</p>

      <div className="form-check">
        <input className="form-check-input" type="checkbox" id="flexCheckCheckedA" onClick={(e)=>{setTipoA(!tipoA)}} />
        <label className="form-check-label" htmlFor="flexCheckCheckedA">
          Información en los datos de la persona
        </label>
      </div>
      {
        tipoA && (
            <div className="form-group">
              <label htmlFor="exampleTextareaA" className="form-label mt-2">Detalles del comentario</label>
              <textarea className="form-control" id="exampleTextareaA" value={descripcionA} onChange={(event)=>{setDescripcionA(event.target.value.toUpperCase())}} rows={3}></textarea>
            </div>
          )
      }


      <div className="form-check mt-2">
        <input className="form-check-input" type="checkbox" id="flexCheckCheckedB" onClick={(e)=>{setTipoB(!tipoB)}} />
        <label className="form-check-label" htmlFor="flexCheckCheckedB">
          Información en los datos del tramite
        </label>
      </div>
      {
        tipoB && (
            <div className="form-group">
              <label htmlFor="exampleTextareaB" className="form-label mt-2">Detalles del comentario</label>
              <textarea className="form-control" id="exampleTextareaB" value={descripcionB} onChange={(event)=>{setDescripcionB(event.target.value.toUpperCase())}} rows={3}></textarea>
            </div>
          )
      }


      <div className="form-check mt-2">
        <input className="form-check-input" type="checkbox" id="flexCheckCheckedC" onClick={(e)=>{setTipoC(!tipoC)}} />
        <label className="form-check-label" htmlFor="flexCheckCheckedC">
          Información en los anexos
        </label>
      </div>
      {
        tipoC && (
            <div className="form-group">
              <label htmlFor="exampleTextareaC" className="form-label mt-2">Detalles del comentario</label>
              <textarea className="form-control" value={descripcionC} onChange={(event)=>{setDescripcionC(event.target.value.toUpperCase())}} id="exampleTextareaC" rows={3}></textarea>
            </div>
          )
      }


      <div className="form-check mt-2">
        <input className="form-check-input" type="checkbox" id="flexCheckCheckedD" onClick={(e)=>{setTipoD(!tipoD)}} />
        <label className="form-check-label" htmlFor="flexCheckCheckedD">
          Otros
        </label>
      </div>
      {
        tipoD && (
            <div className="form-group">
              <label htmlFor="exampleTextareaD" className="form-label mt-2">Detalles del comentario</label>
              <textarea className="form-control" value={descripcionD} onChange={(event)=>{setDescripcionD(event.target.value.toUpperCase())}} id="exampleTextareaD" rows={3}></textarea>
            </div>
          )
      }



            {
              comments.comments.length > 0 && (
                  <p className="mt-4">Comentarios anteriores: </p>
              )
            }

            


            {
              comments.comments.map( (comentario:any,i:number) =>

                  <React.Fragment key={comentario.uuid}>

                      <div  className="card" style={{ margin: '5px 0'}}>
                        <div className="card-body">
                          <h6 className="card-subtitle text-muted"><b>{(i+1)}.-</b> {comentario.tipo_comentario} <i style={{color:"green"}} className="fa fa-check-circle"/></h6>
                          <p style={{marginBottom:0}} className="card-text">{comentario.descripcion}</p>
                        </div>
                      </div>

                    {
                      // JSON.stringify(comentario)
                    }
                  </React.Fragment>

                )
            }




        </Modal.Body>
        <Modal.Footer>
          <Button onClick={()=>{enviarRectificacion()}} variant="primary">Enviar a Rectificación</Button>
        </Modal.Footer>
      </Modal>



      {
        showEditarTramite && (
            <EditarTramite show={showEditarTramite} uuid_tramite={uuid_tramite} tramite={data_tramite} departamento={departamento_edicion} mesa_atencion={true} onHide={handleCloseEditarTramite} />
         )
      }


      {
        showModalDetalleCobranza && (
            <ModalDetalleCobranza is_admin={true} uuid_tramite={uuid_tramite_modal} onHideModalDetalleCobranza={onHideModalDetalleCobranza} showModalDetalleCobranza={showModalDetalleCobranza} />
         )
      }



      {
        showModalAnexos && (
            <ModalAnexoMesa uuid_tramite={uuid_tramite_modal} onHideModalAnexos={onHideModalAnexos} showModalAnexos={showModalAnexos} />
         )
      }




      {
        showModalReportes && (
            <ModalReporte onHideModalReportes={onHideModalReportes} showModalReportes={showModalReportes} />
         )
      }




      {
        showModalInforme && (
            <ModalInformeTramite onHideModalInforme={onHideModalInforme} showModalInforme={showModalInforme} uuid_tramite={uuid_tramite_modal} />
         )
      }



  {
    show_ModalNotasTramite && (
      <ModalNotasTramite show={show_ModalNotasTramite} handleClose={handleClose_ModalNotasTramite} tramite={data_tramite} />
      )

  }



  {
    show_ModalEditarInformacionSolicitante && (
      <ModalEditarInformacionSolicitante show={show_ModalEditarInformacionSolicitante} handleClose={handleClose_ModalEditarInformacionSolicitante} solicitante={solicitante} />
      )

  }



  {
    show_ModalEnviarTramitePago && (
      <ModalEnviarTramitePago show={show_ModalEnviarTramitePago} handleClose={handleClose_ModalEnviarTramitePago} tramite={data_tramite}  />
      )

  }







  {
    show_ModalEditarFechasAseguramiento && (
      <ModalEditarFechasAseguramiento show={show_ModalEditarFechasAseguramiento} handleClose={handleClose_ModalEditarFechasAseguramiento} tramite={data_tramite} />
      )

  }






  {
    show_ModalLayoutSUE && (
      <ModalLayoutSUE show={show_ModalLayoutSUE} handleClose={handleClose_ModalLayoutSUE}  />
      )

  }



          </>

      );
  

}

export default MesaAtencion
